import BillingsPlanEntryTaxiDriverAddRequest, {
  BillingsPlanEntryTaxiDriverAddRequestBody,
} from "./billings-plan-entry-taxi-driver-add.request";

const createBody = (
  request: BillingsPlanEntryTaxiDriverAddRequest,
): BillingsPlanEntryTaxiDriverAddRequestBody => {
  return {
    billingContributions: request.billingContributions,
    billingNodes: request.billingNodes,
  };
};

const billingsPlanEntryTaxiDriverAddRequestFactory = {
  createBody,
};

export default billingsPlanEntryTaxiDriverAddRequestFactory;
